import { observable, transaction } from 'mobx';
import { IPcScrollService } from './pc-scroll-service.interface';

export default class PcScrollService implements IPcScrollService {
    /**
     * 当前滚动的x
     */
    @observable
    public currentScrollX = 0;
    /**
     * 当前滚动的y
     */
    @observable
    public currentScrollY = 0;
    /**
     * 当前 canvas 画布 x 轴偏移
     */
    public currentTranslateX = 0;
    /**
     * 当前 canvas 画布 y 轴偏移
     */
    public currentTranslateY = 0;

    public updateCurrentScroll(currentScrollX, currentScrollY) {
        transaction(() => {
            this.currentScrollX = currentScrollX;
            this.currentScrollY = currentScrollY;
        });
    }

    public updateCurrentCanvasTranslate(translateX, translateY) {
        this.currentTranslateX = translateX;
        this.currentTranslateY = translateY;
    }
}
